module.exports = __webpack_public_path__ + "static/media/file_add_grey.d411497c.svg";